import { render } from "./RadioInline.vue?vue&type=template&id=e5bea720"
import script from "./RadioInline.vue?vue&type=script&lang=js"
export * from "./RadioInline.vue?vue&type=script&lang=js"
script.render = render

export default script